import Vue from 'vue'

import { MutationTree } from 'vuex'

import { OrderPayment, OrderPaymentFilters } from '@/models'

import { makeRelationalObject } from '../../models'
import { InvoiceOrderPayments, OrderingState } from '../state'

export const ADD_INVOICE_ORDER_PAYMENTS = 'ADD_INVOICE_ORDER_PAYMENTS'
export const ADD_ORDER_PAYMENT = 'ADD_ORDER_PAYMENT'
export const APPLY_ORDER_PAYMENT_FILTERS = 'APPLY_ORDER_PAYMENT_FILTERS'
export const CLEAR_INVOICES_ORDER_PAYMENTS = 'CLEAR_INVOICES_ORDER_PAYMENTS'
export const INCREMENT_ORDER_PAYMENTS_QUERY_INDEX = 'INCREMENT_ORDER_PAYMENTS_QUERY_INDEX'
export const LOADED_ALL_INVOICE_ORDER_PAYMENTS = 'LOADED_ALL_INVOICE_ORDER_PAYMENTS'
export const LOADED_ALL_ORDER_PAYMENTS = 'LOADED_ALL_ORDER_PAYMENTS'
export const RESET_LOADED_ALL_ORDER_PAYMENTS = 'RESET_LOADED_ALL_ORDER_PAYMENTS'
export const RESET_LOADED_ALL_INVOICE_ORDER_PAYMENTS = 'RESET_LOADED_ALL_INVOICE_ORDER_PAYMENTS'
export const RESET_ORDER_PAYMENTS_QUERY_INDEX = 'RESET_ORDER_PAYMENTS_QUERY_INDEX'
export const SET_ORDER_PAYMENTS_DEFAULT_FILTERS_FLAG = 'SET_ORDER_PAYMENTS_DEFAULT_FILTERS_FLAG'
export const UPDATE_INVOICE_ORDER_PAYMENTS = 'UPDATE_INVOICE_ORDER_PAYMENTS'
export const UPDATE_INVOICE_ORDER_PAYMENTS_TOTAL = 'UPDATE_INVOICE_ORDER_PAYMENTS_TOTAL'
export const UPDATE_ORDER_PAYMENTS = 'UPDATE_ORDER_PAYMENTS'
export const UPDATE_ORDER_PAYMENTS_TOTAL = 'UPDATE_ORDERS_TOTAL'

const mutations: MutationTree<OrderingState> = {
  [ADD_INVOICE_ORDER_PAYMENTS] (state, invoiceId: number) {
    const invoiceOrderPayments: InvoiceOrderPayments = makeRelationalObject()

    Vue.set(state.invoices.orderPayments, invoiceId, invoiceOrderPayments)
  },

  [ADD_ORDER_PAYMENT] (state, orderPayment: OrderPayment) {
    state.orderPayments.elements.push(orderPayment)
  },

  [APPLY_ORDER_PAYMENT_FILTERS] (state, filters: OrderPaymentFilters) {
    const old = state.orderPayments.query

    state.orderPayments.query = {
      offset: old.offset,
      limit: old.limit,
      applicationType: old.applicationType,
      ...filters
    }
  },

  [CLEAR_INVOICES_ORDER_PAYMENTS] (state) {
    state.invoices.orderPayments = {}
  },

  [INCREMENT_ORDER_PAYMENTS_QUERY_INDEX] (state, offset: number) {
    state.orderPayments.query.offset = (state.orderPayments.query.offset ?? 0) + offset
  },

  [LOADED_ALL_INVOICE_ORDER_PAYMENTS] (state, invoiceId: number) {
    const invoiceOrderPayments = state.invoices.orderPayments[invoiceId]

    if (invoiceOrderPayments === undefined) {
      throw new Error(`OrderPayments relation for Invoice "${invoiceId}" was not found`)
    }

    invoiceOrderPayments.didLoadAll = true
  },

  [LOADED_ALL_ORDER_PAYMENTS] (state) {
    state.orderPayments.didLoadAll = true
  },

  [SET_ORDER_PAYMENTS_DEFAULT_FILTERS_FLAG] (state, isDefaultFilters: boolean) {
    state.orderPayments.isDefaultFilters = isDefaultFilters
  },

  [RESET_LOADED_ALL_INVOICE_ORDER_PAYMENTS] (state, invoiceId: number) {
    const invoiceOrderPayments = state.invoices.orderPayments[invoiceId]

    if (invoiceOrderPayments === undefined) {
      throw new Error(`OrderPayments relation for Invoice "${invoiceId}" was not found`)
    }

    invoiceOrderPayments.didLoadAll = false
  },

  [RESET_LOADED_ALL_ORDER_PAYMENTS] (state) {
    state.orderPayments.didLoadAll = false
  },

  [RESET_ORDER_PAYMENTS_QUERY_INDEX] (state) {
    state.orderPayments.query.offset = 0
  },

  [UPDATE_INVOICE_ORDER_PAYMENTS] (
    state,
    { invoiceId, orderPayments }: { invoiceId: number; orderPayments: number[] }
  ) {
    const invoiceOrderPayments = state.invoices.orderPayments[invoiceId]

    if (invoiceOrderPayments === undefined) {
      throw new Error(`OrderPayments relation for Invoice "${invoiceId}" was not found`)
    }

    invoiceOrderPayments.ids = new Set(orderPayments)
  },

  [UPDATE_INVOICE_ORDER_PAYMENTS_TOTAL] (
    state,
    { invoiceId, total }: { invoiceId: number; total: number }
  ) {
    const invoiceOrderPayments = state.invoices.orderPayments[invoiceId]

    if (invoiceOrderPayments === undefined) {
      throw new Error(`OrderPayments relation for Invoice "${invoiceId}" was not found`)
    }

    invoiceOrderPayments.total = total
  },

  [UPDATE_ORDER_PAYMENTS] (state, orderPayments: OrderPayment[]) {
    state.orderPayments.elements = orderPayments
  },

  [UPDATE_ORDER_PAYMENTS_TOTAL] (state, total: number) {
    state.orderPayments.total = total
  }
}

export default mutations
